module.exports = __webpack_public_path__ + "img/ring_r_skip_0_null@3x.ff46672c.png";